import { Injectable } from '@angular/core';

import { FirestoreService } from '@msi/core/dao/firebase/firestore';

import { BfitComputerPool } from './entities/bfit-computer-pool';
import { BfitOrganization } from './bfit-organizations';
import { Observable, of } from 'rxjs';
import { DBService } from '@msi/core/dao/db';

export * from './entities/bfit-computer-pool';


@Injectable({ providedIn: 'root' })
export class BfitComputerPoolsService extends DBService<BfitComputerPool> {

    constructor(db: FirestoreService) {
        super('bfit-computer-pools', db);
    }

    findAllForOrganization(org: BfitOrganization): Observable<BfitComputerPool[]> {
        return org ? super.getAll(ref => ref.where('bfit_org_ref.id', '==', org.id)) : of([]);
    }

}